import "./appLayout.scss";

import { AppSidebar } from "./AppSidebar";
import ScrollToTop from "../hooks/useRouteChange";
import { PageNotFoundElement } from "../components/layout/PageNotFoundElement";

const DashboardPageNotFound = ({ children }) => {
  return (
    <>
      <ScrollToTop />
      <div className="app">
        {/* sidebar */}
        <AppSidebar />
        {/* content */}
        <div className="app-content-wrapper">
          <div className="app-content">
            <PageNotFoundElement />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardPageNotFound;
